import { type Translations } from "./en";

export const zh: Translations = {
  // ─── Navbar ───
  nav: {
    home: "首页",
    about: "关于我们",
    services: "服务",
    kols: "KOL资源",
    howWeWork: "合作流程",
    contact: "联系我们",
    getInTouch: "立即咨询",
  },

  // ─── Hero ───
  hero: {
    tag: "全球KOL营销代理机构",
    headline1: "连接品牌",
    headline2: "触达全球",
    sub: "从KOL合作到PR宣发——助力中国品牌走向全球103个国家，实现真实增长。",
    cta: "开启合作",
    stats: [
      { value: "120万+", label: "全球KOL资源" },
      { value: "103", label: "覆盖国家" },
      { value: "40亿+", label: "累计触达受众" },
      { value: "50+", label: "合作品牌" },
    ],
  },

  // ─── About ───
  about: {
    eyebrow: "关于 Ascend",
    headline1: "根植中国，",
    headline2: "放眼全球。",
    body: "Ascend 是一家总部位于深圳、在香港设有办公室的全球营销机构。我们专注于通过网红营销、线下活动、PR宣发及社媒代运营，助力中国品牌拓展海外市场。数据驱动的方法确保每一场战役都产生可量化的影响。",
    advantages: [
      {
        num: "01",
        label: "精准触达",
        desc: "103个国家 · 27种语言 · 40亿+受众覆盖，基于多维受众画像的科学匹配——每一次触达都精准落在目标消费群体面前。",
      },
      {
        num: "02",
        label: "高效执行",
        desc: "从需求洞察、达人筛选到内容上线、数据复盘，全链路闭环交付。一站式项目管理大幅缩短品牌从决策到市场的响应周期。",
      },
      {
        num: "03",
        label: "数据驱动",
        desc: "实时效果监测系统覆盖曝光、互动、转化全维度指标，透明化报告让每一分预算都有据可循。",
      },
      {
        num: "04",
        label: "长期价值",
        desc: "致力于与品牌建立长期战略合作关系。超过50+合作项目中，70%以上的客户选择续签或扩大合作规模。",
      },
    ],
    platforms: "覆盖平台",
    statsRow: [
      { value: "120万+", label: "全球KOL资源库" },
      { value: "103个", label: "覆盖国家" },
      { value: "40亿+", label: "累计触达受众" },
      { value: "27种", label: "支持语言" },
    ],
  },

  // ─── Services ───
  services: {
    eyebrow: "我们的服务",
    headline1: "全链路营销服务",
    headline2: "覆盖每个增长节点",
    subtitle: "无论是网红合作、线下活动、PR媒体覆盖还是社媒增长，我们提供量身定制的一体化解决方案。",
    tabs: [
      "网红营销",
      "线下活动",
      "PR宣发",
      "社媒代运营",
    ],
    items: [
      {
        title: "网红营销 / Creator Partnerships",
        subtitle: "精准匹配 · 高效执行 · 可量化回报",
        description:
          "从达人筛选、创意策划、内容共创到效果追踪，提供端到端的网红营销服务，涵盖 TikTok / Instagram / YouTube / Snapchat 等全球主流平台，助力品牌实现真实的用户连接与可持续的转化增长。",
        items: [
          "全球达人资源库：103个国家KOL资源，精准匹配品牌调性与目标受众",
          "达人筛选与背调：受众分析、互动率评估、价值契合度审核、合规风控",
          "内容策略共创：创意脚本、拍摄方向、平台适配，最大化内容影响力",
          "执行管理与监测：实时追踪播放量、互动率、转化数据",
          "效果分析与优化：完整结案报告，持续迭代营销策略",
        ],
      },
      {
        title: "线下活动 / Experiential Marketing",
        subtitle: "沉浸体验 · 品牌共鸣 · 破圈传播",
        description:
          "从品牌发布会、Pop-up 体验店到快闪活动，为品牌打造可参与、可传播的线下场景，让每一位参与者都成为品牌的主动传播者。结合达人邀约与线上联动，激活活动的社交声量，实现线下体验与线上传播的闭环。",
        items: [
          "活动策划与创意：主题概念、场景设计、流程规划",
          "达人邀约与现场执行：精准邀约匹配达人，提升活动传播势能",
          "线上线下联动：实时社媒发酵，延长活动生命周期",
          "效果追踪与复盘：参与数据、传播数据、用户反馈全维度分析",
        ],
      },
      {
        title: "PR 宣发 / Media Relations & PR",
        subtitle: "权威背书 · 全球媒体网络 · 精准传播",
        description:
          "构建了覆盖全球顶级媒体与垂直领域的媒体资源网络，帮助品牌在关键节点实现最大化曝光与正面声量。",
        items: [
          "顶级媒体发稿：BBC / Forbes / TIME / CNN / Bloomberg 等综合权威媒体",
          "垂直领域媒体：科技 / 3C打印 / 区块链 / 时尚等细分行业精准覆盖",
          "新闻稿撰写：品牌故事、新闻事件、产品发布等专业内容创作",
          "媒体关系维护：长期媒体关系建设与维护",
          "舆情监测与危机公关：实时监测，及时响应，维护品牌声誉",
        ],
      },
      {
        title: "社媒代运营 / Social Media Management",
        subtitle: "持续运营 · 内容驱动 · 社区沉淀",
        description:
          "不只是发布内容，更是通过持续运营帮助品牌建立稳定的用户社区，提升粉丝粘性与品牌忠诚度。覆盖 TikTok / Instagram / Facebook / LinkedIn 等全球主流平台，基于数据驱动的运营策略，实现品牌影响力的长期建设。",
        items: [
          "账号诊断与定位：行业分析、竞争监测、差异化定位策略",
          "内容策划与创作：热点话题策划、原创图文/视频内容、视觉设计",
          "社区互动管理：粉丝互动、评论回复、用户运营",
          "广告投放与优化：精准定向投放，持续优化ROI",
          "数据复盘与迭代：月度/季度数据报告，策略持续优化",
        ],
      },
    ],
    learnMore: "了解更多",
    inquire: "咨询此服务",
    itemsLabel: "服务内容包含",
    cta: "探讨合作方案",
  },

  // ─── KOL Showcase ───
  kol: {
    eyebrow: "KOL 资源",
    headline1: "120万创作者，",
    headline2: "103个国家。",
    sub: "从超级头部达人到垂直细分KOC——我们的专属资源库覆盖全球每一个平台、类目与市场，为品牌找到最适合的发声者。",
    filters: ["全部", "YouTube", "Instagram", "TikTok"],
    subscribers: "粉丝数",
    totalViews: "总播放量",
    category: "内容方向",
    region: "覆盖地区",
    platforms: "活跃平台",
    partnerBrands: "合作品牌",
    highlight: "亮点",
    viewChannel: "查看频道",
    cta: "访问完整KOL资源库",
    ctaSub: "103个国家、120万+达人——让我们为你的品牌找到最匹配的声音。",
    ctaBtn: "申请KOL匹配",
  },

  // ─── Testimonials / Case Studies ───
  testimonials: {
    eyebrow: "合作案例",
    headline1: "数据说话，",
    headline2: "案例为证",
    sub: "真实品牌，真实战役，真实成果。",
    prevPage: "上一页",
    nextPage: "下一页",
    market: "市场",
    platforms: "平台",
    readMore: "展开详情",
    collapse: "收起",
    reviewsTitle: "客户评价",
    caseStudies: [
      {
        brand: "Alipay 支付宝",
        category: "金融科技",
        market: "韩国 · 马来西亚 · 香港 · 澳门",
        headline: "亚运会跨境联动：30+达人覆盖四市场，海外曝光突破800万",
        detail:
          "2023年8月，Ascend与支付宝建立长期合作，承接韩国、马来西亚、香港、澳门四地线上推广。借助杭州亚运会节点，邀约各国达人深度参与宣传，以真实入华消费体验展示Alipay+跨境支付便利性，助力品牌在海外建立认知并拓展用户规模。",
        metrics: [
          { value: "800万+", unit: "", label: "海外曝光量" },
          { value: "30+", unit: "达人", label: "四市场联动" },
        ],
      },
      {
        brand: "HONGQI 红旗",
        category: "高端新能源汽车",
        market: "中东 · 挪威",
        headline: "斋月公益挑战赛引爆中东声量，每转发捐1美元激活粉丝热情",
        detail:
          "2023年4-5月，Ascend为红旗汽车策划中东斋月挑战赛，邀请迪拜、约旦、沙特、科威特头部KOL参与传播。每转发一条帖子红旗捐赠1美元，公益机制极大激活粉丝参与度，显著提升品牌美誉度。同年8月再度联手打造挪威旅游季主题活动，持续拓展红旗欧洲市场高端形象。",
        metrics: [
          { value: "中东+挪威", unit: "", label: "双市场布局" },
          { value: "公益联动", unit: "", label: "粉丝高参与" },
        ],
      },
      {
        brand: "TEMU",
        category: "跨境电商",
        market: "全球多市场",
        headline: "12国KOL矩阵精准投放，助力平台快速建立全球用户认知",
        detail:
          "Ascend为TEMU量身定制全球多市场KOL资源匹配与投放方案，聚合500+位各国本土达人，精准触达目标消费群体，助力平台在12个海外市场实现品牌认知快速建立，新用户获取效率大幅提升。",
        metrics: [
          { value: "12", unit: "个市场", label: "全球覆盖" },
          { value: "500+", unit: "达人", label: "合作规模" },
        ],
      },
      {
        brand: "Ulike",
        category: "美容个护",
        market: "美国",
        headline: "三大平台KOL全渠道种草，脱毛仪品牌美国市场精准破圈",
        detail:
          "Ascend为Ulike在美国市场甄选优质本土KOL，覆盖TikTok、Instagram、YouTube三大主流平台，通过达人真实使用体验内容，精准传递品牌核心价值，显著提升目标用户群体的品牌认知度与购买转化。",
        metrics: [
          { value: "3", unit: "大平台", label: "全渠道覆盖" },
          { value: "美国", unit: "市场", label: "精准破圈" },
        ],
      },
      {
        brand: "海信 Hisense",
        category: "消费电子",
        market: "美国 · 西班牙 · 南非",
        headline: "三国同步推广，15天自然流量突破30万+",
        detail:
          "2023年11-12月，Ascend协助海信在美国、西班牙、南非三大市场同步开展品牌推广活动，依托本土达人与精准内容策略，短短15天内累计实现自然流量突破30万，有效提升海信在多个海外市场的品牌声量。",
        metrics: [
          { value: "30万+", unit: "", label: "15天自然流量" },
          { value: "3国", unit: "同步", label: "多市场联动" },
        ],
      },
      {
        brand: "澳门旅游局",
        category: "旅游推广",
        market: "国际多市场",
        headline: "多国达人第一视角实拍，澳门旅游国际影响力全面提升",
        detail:
          "Ascend与澳门旅游局保持长期战略合作，邀请来自不同国家和地区的达人实地探访澳门，以真实第一视角记录世遗景点、娱乐体验、地道美食全程，持续强化澳门作为国际顶级旅游目的地的品牌形象。",
        metrics: [
          { value: "多国", unit: "达人", label: "矩阵覆盖" },
          { value: "长期", unit: "合作", label: "战略伙伴" },
        ],
      },
      {
        brand: "识季 SENSER",
        category: "奢侈品零售",
        market: "香港 · 澳门",
        headline: "精准渗透港澳高端圈层，助力全球奢品平台本地品牌升级",
        detail:
          "Ascend与识季SENSER达成营销合作，专项负责香港及澳门区域的红人营销服务，通过本地优质KOL精准触达港澳高净值消费群体，提升品牌知名度与用户转化，助力识季全球2500+品牌专柜的海外推广。",
        metrics: [
          { value: "2500+", unit: "", label: "品牌专柜" },
          { value: "60+", unit: "国家", label: "全球覆盖" },
        ],
      },
      {
        brand: "领克 LYNK & CO",
        category: "新能源汽车",
        market: "中东",
        headline: "20位中东达人TikTok挑战赛，5天观看量突破两千万",
        detail:
          "2023年11月，Ascend联合领克汽车策划中东TikTok挑战赛，精准邀约20位中东本土头部达人参与，短短5天内话题挑战赛观看量突破两千万，实现领克品牌在中东市场前所未有的声量爆发。",
        metrics: [
          { value: "2000万", unit: "", label: "5天观看量" },
          { value: "20位", unit: "达人", label: "中东头部" },
        ],
      },
      {
        brand: "Jagat",
        category: "元宇宙社交",
        market: "日本",
        headline: "TikTok红人矩阵快速破圈，元宇宙平台日本市场曝光250万",
        detail:
          "2023年5月，Ascend携手Jagat虚拟世界社交平台开启日本市场推广合作，通过精准匹配本土TikTok红人矩阵，以沉浸式互动体验内容为核心，迅速打开日本年轻用户群体，仅此阶段即实现250万曝光量。",
        metrics: [
          { value: "250万", unit: "", label: "曝光量" },
          { value: "TikTok", unit: "", label: "核心平台" },
        ],
      },
      {
        brand: "imo",
        category: "社交通讯",
        market: "全球",
        headline: "50位达人双平台联动，品牌话题标签浏览量破530万",
        detail:
          "2023年11月，Ascend为imo全球免费视频通话平台协调50位达人，在TikTok与Instagram双平台同步发布推广内容，品牌相关话题标签浏览量达到530万次，有效扩大imo在目标市场的用户认知。",
        metrics: [
          { value: "530万", unit: "", label: "话题浏览量" },
          { value: "50位", unit: "达人", label: "双平台联动" },
        ],
      },
      {
        brand: "POIZON",
        category: "潮流电商",
        market: "英国 · 美国 · 韩国 · 印尼",
        headline: "四国长期KOL合作矩阵，潮流电商平台持续破圈",
        detail:
          "Ascend与POIZON达成长期月度合作，系统化管理英国、美国、韩国、印尼四大市场的KOL投放，覆盖YouTube、TikTok、Instagram多平台，持续输出高质量潮流内容，构建品牌在全球年轻消费群体中的稳定声量。",
        metrics: [
          { value: "4国", unit: "市场", label: "长期合作" },
          { value: "月度", unit: "持续", label: "稳定投放" },
        ],
      },
      {
        brand: "春莱 Chunlai",
        category: "餐饮连锁",
        market: "东南亚",
        headline: "童星代言×线下联动，春莱奶茶品牌年轻化精准破圈",
        detail:
          "Ascend策划春莱茶饮与印尼知名童星Tatan的短期代言合作，线上社交媒体宣传与线下门店同步推进，定制专属门店物料强化沉浸式消费体验，精准切入年轻消费群体，有效提升品牌热度。",
        metrics: [
          { value: "线上+线下", unit: "", label: "全域联动" },
          { value: "Tatan", unit: "代言", label: "童星效应" },
        ],
      },
      {
        brand: "大胡子冰可可",
        category: "茶饮品牌",
        market: "东南亚",
        headline: "节日IP×童星流量，圣诞营销破圈年轻圈层",
        detail:
          "圣诞及新年节点，Ascend为大胡子冰可可策划童星Tatan品牌联名合作，线上线下同步激活，节日主题门店定制物料增强消费体验，成功拉动节假日品牌热度，160+家门店全面参与联动。",
        metrics: [
          { value: "160+", unit: "家", label: "门店联动" },
          { value: "节日爆款", unit: "", label: "社媒声量" },
        ],
      },
      {
        brand: "ELFBAR",
        category: "电子雾化",
        market: "美国 · 欧洲 · 中东 · 东南亚",
        headline: "全渠道KOL矩阵，8国深度覆盖助力电雾品牌全球破圈",
        detail:
          "自2022年8月起，Ascend为ELFBAR提供全球全渠道推广服务，深度渗透美国、英国、德国、法国、加拿大、中东、东南亚及希腊等核心市场，助力品牌建立国际认知并实现快速用户增长。",
        metrics: [
          { value: "8+", unit: "国家", label: "市场覆盖" },
          { value: "KOL+PR", unit: "", label: "双轨并进" },
        ],
      },
      {
        brand: "Geekvape",
        category: "电子雾化",
        market: "海外重点市场",
        headline: "11位达人UGC挑战赛联动，总播放量243万精准曝光",
        detail:
          "围绕Geekvape「Hunt Geekvape」品牌活动，Ascend精选11位海外达人，以30-60秒短视频展示「闪电瞬间」，引导粉丝发布UGC参与互动，显著提升品牌在目标市场的声量与粉丝粘性。",
        metrics: [
          { value: "243万", unit: "", label: "总播放量" },
          { value: "11位", unit: "达人", label: "UGC联动" },
        ],
      },
      {
        brand: "Vaporesso",
        category: "电子雾化",
        market: "全球",
        headline: "深度品牌共建，助力Vaporesso构建全球KOL生态矩阵",
        detail:
          "Ascend与Vaporesso达成长期战略合作，从达人甄选、内容共创到全平台分发，协助Vaporesso在海外市场建立持续、稳定的品牌声量，强化其作为全球领先电子雾化品牌的市场地位。",
        metrics: [
          { value: "长期", unit: "合作", label: "战略伙伴" },
          { value: "全球", unit: "矩阵", label: "KOL生态" },
        ],
      },
      {
        brand: "DOJO",
        category: "电子雾化",
        market: "英国",
        headline: "TikTok+Instagram双平台联动，新品首发曝光突破376万",
        detail:
          "DOJO BLAST2000 GO新品上市期间，Ascend整合11位英国本土达人，以TikTok为主（82%）、Instagram为辅（18%）的渠道组合，精准传递核心卖点，内容高度适配年轻群体审美与互动习惯。",
        metrics: [
          { value: "376万", unit: "", label: "总曝光量" },
          { value: "11位", unit: "达人", label: "英国本土" },
        ],
      },
      {
        brand: "Lost Vape",
        category: "高级电子雾化",
        market: "波兰",
        headline: "新品预热×本土KOL，Lost Vape波兰市场精准破圈",
        detail:
          "2023年4月，Ascend与Lost Vape达成合作，为其新品上市提供波兰本土KOL营销服务。通过精选与品牌调性高度契合的达人，以真实测评与生活方式内容进行预热，精准渗透波兰年轻消费群体，有效提升Lost Vape品牌知名度与市场影响力。",
        metrics: [
          { value: "波兰", unit: "市场", label: "精准投放" },
          { value: "新品预热", unit: "", label: "品牌破圈" },
        ],
      },
    ],
    reviews: [
      {
        quote:
          "Ascend对海外市场的深刻理解让我们印象深刻。他们不只是执行团队，更是真正懂品牌的战略伙伴。从策划到复盘报告，每个环节都展现出极高的专业水准。",
        author: "Sarah Mitchell",
        title: "全球品牌总监",
        company: "头部跨境电商品牌",
        market: "美国 · 欧洲",
      },
      {
        quote:
          "KOL筛选流程严格透明，每一位达人都精准契合我们的品牌调性。与Ascend合作后，中东市场声量爆发式增长——5天内突破2000万播放量，完全超出预期。",
        author: "James Whitfield",
        title: "市场营销总监",
        company: "高端新能源汽车品牌",
        market: "中东 · 沙特阿拉伯",
      },
      {
        quote:
          "Ascend帮助我们在东南亚快速规模化增长。他们对本地达人生态的深入了解和内容本土化能力，让我们在竞争中占据明显优势，ROI远超行业基准。",
        author: "Lucas Bennett",
        title: "增长负责人",
        company: "全球科技与社交平台",
        market: "东南亚 · 日本",
      },
    ],
  },

  // ─── How We Work ───
  howWeWork: {
    eyebrow: "合作流程",
    headline1: "七步精准执行，",
    headline2: "每一步都有据可循",
    sub: "严谨、透明、结果导向的合作流程——让品牌始终知道正在发生什么，以及为什么这样做。",
    body: "我们打磨了一套经过实战检验的执行体系，确保每一场战役准时、贴合品牌调性、精准命中目标。",
    tagline: "七步到位，零意外。",
    steps: [
      {
        num: "01",
        enLabel: "Discovery",
        title: "需求洞察 & 策略定制",
        summary: "从倾听开始，在任何创意决策之前先明确清晰的KPI与成功标准。",
        detail:
          "我们从倾听开始。通过深入的沟通，我们全面理解你的品牌基因、目标市场与增长目标，在任何创意决策之前，先明确清晰的KPI、预算框架以及成功衡量标准。",
      },
      {
        num: "02",
        enLabel: "KOL Selection",
        title: "数据驱动 & 达人筛选",
        summary: "从数百个维度严格筛选，关注受众画像、互动质量与品牌契合度。",
        detail:
          "基于自有数据分析系统，从数百个维度进行严格筛选，匹配最合适的KOL/KOC。不仅仅看粉丝量，更关注受众画像、互动质量、内容真实性以及品牌契合度——每一次匹配都经过精心设计。",
      },
      {
        num: "03",
        enLabel: "Negotiation",
        title: "精准对接 & 商务谈判",
        summary: "全程负责达人沟通与商务谈判，确保条款清晰透明，最大化保障品牌利益。",
        detail:
          "我们全程负责达人沟通、关系建立及合作谈判，确保在交付内容、使用权限、执行时间以及费用等方面条款清晰透明，最大程度保障你的利益。",
      },
      {
        num: "04",
        enLabel: "Co-Creation",
        title: "联合创意 & 内容共创",
        summary: "策略与创意团队深度参与，发布前你将拥有最终审核权。",
        detail:
          "我们的策略与创意团队将与达人紧密协作，共同打造符合平台生态的内容，结合品牌调性与本地文化语境。在内容发布前，你将拥有最终审核权——在保证品牌一致性的前提下释放创意空间。",
      },
      {
        num: "05",
        enLabel: "Publishing",
        title: "协同发布 & 全域放大",
        summary: "统筹多平台发布节奏，协调合规与多渠道传播，实现最大化曝光。",
        detail:
          "我们统筹Instagram、TikTok、YouTube等平台的发布节奏，协调发布时间、合规要求、多渠道传播及社区互动，实现最大化曝光与真实互动。",
      },
      {
        num: "06",
        enLabel: "Optimization",
        title: "实时追踪 & 动态优化",
        summary: "实时数据看板持续追踪核心指标，透明周报月报，及时中期调整优化。",
        detail:
          "通过实时数据看板，我们持续追踪曝光、互动、转化及ROI等核心指标，提供透明的周报与月报，并根据数据表现及时进行中期优化调整。",
      },
      {
        num: "07",
        enLabel: "Debrief",
        title: "深度复盘 & 内容资产化",
        summary: "项目结束后输出完整复盘报告，优质内容转化为可复用广告素材。",
        detail:
          "项目结束后，我们将输出完整复盘报告，包括KPI达成情况、策略洞察以及后续优化方向。同时，将优质内容转化为可复用的广告素材，持续放大投放效果，实现长期ROI增长。",
      },
    ],
    cta: "开启你的战役",
    ctaTitle: "准备好开启合作了吗？",
    ctaSub: "联系我们，获取专属营销策略方案",
    ctaBtn: "立即咨询",
  },

  // ─── Contact ───
  contact: {
    eyebrow: "联系我们",
    headline1: "让我们一起",
    headline2: "创造增长",
    sub: "准备好让品牌走向全球了吗？告诉我们你的战役目标，我们将在24小时内回复。",
    sent: "消息已发送！",
    sentBody: "感谢您的联系，我们的团队将在24小时内回复您。",
    emailSubject: "来自 {name} 的合作咨询",
    fieldName: "姓名",
    fieldCompany: "公司名称",
    fieldEmail: "电子邮箱",
    fieldMessage: "留言",
    fieldMessagePlaceholder: "请告诉我们您的战役目标、目标市场和预算范围...",
    formTitle: "开启合作对话",
    formSub: "我们将在24小时内回复",
    send: "发送消息",
    items: [
      { label: "深圳总部", value: "深圳市龙岗区珠江国际中心 11楼" },
      { label: "香港办公室", value: "九龙尖沙咀漆咸道南87-105号\n百利商业中心1022A室" },
      { label: "合作邮箱", value: "sylvia@chinaascend.net\njulien@chinaascend.net" },
      { label: "联系电话", value: "+86 153 2382 3591" },
      { label: "Telegram / WhatsApp", value: "+86 15323823591" },
      { label: "微信", value: "1647226901" },
      { label: "Instagram", value: "@ascend_marketingagency" },
    ],
    form: {
      name: "姓名",
      company: "公司名称",
      email: "电子邮箱",
      message: "告诉我们你的合作需求",
      send: "发送消息",
      success: "消息已发送！我们将在24小时内与您联系。",
    },
  },

  // ─── Footer ───
  footer: {
    tagline: "全球网红营销与品牌增长代理机构",
    navCols: [
      {
        title: "服务",
        links: ["网红营销", "线下活动", "PR 宣发", "社媒代运营"],
      },
      {
        title: "关于",
        links: ["品牌故事", "核心业务", "我们的优势", "合作理念"],
      },
      {
        title: "联系",
        links: ["立即咨询", "深圳总部", "香港办公室", "发送邮件"],
      },
    ],
    legal: ["隐私政策", "服务条款"],
  },

  // ─── KOL Showcase (KOLShowcase component) ───
  kols: {
    eyebrow: "KOL Resources · 全球达人资源",
    headline1: "顶级 KOL 资源",
    headline2: "覆盖全球主流赛道",
    subscribers: "订阅者",
    views: "总播放",
    viewChannel: "查看频道",
    brandPartners: "合作品牌",
    kolCtaText: "有意与此 KOL 合作？联系我们获取专属方案",
    getProposal: "获取合作方案",
    resourceNote: "以上为部分展示资源 · 我们拥有\u00a0120万+\u00a0全球 KOL 资源库",
    getFullList: "获取完整资源库",
  },
};